
import { useEffect, useState } from 'react';
import { Config } from 'src/config';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import CustomDomainRedirectIframe from '../customDomainIframe';
import { PostUtil } from 'src/pages/new-post-new/post-util';
import InstagramDirectAuthorizationModal from '../instagramIntegration/instagramDirectAuthorizationModel';

const InstagramDirectReAuthenticate = ({ AccountId, handleClose, getConnectedNetworks }) => {
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  let isProcessing = false;
  const isCustomDomain = CommonHelper.CustomDomain();
  let intervalId = null;

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAuthoCodeReceivedFromFacebook();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const instagramAccountSuccessCallback = (data, message) => {
    showToast(message, 's');
    getConnectedNetworks();
    handleClose();
  };
  const instagramAccountFailureCallback = (message) => {
    showToast(message, 'e');
    handleClose();
  };
  const getInstagramAccounts = (code) => {
    let instagramForm = {
      code,
      account_id: AccountId,
    };
    let postProps = {
      url: integrateModuleURL.directReAuthenticateInstagramAccounts,
      body: instagramForm,
      successCallback: instagramAccountSuccessCallback,
      failureCallback: instagramAccountFailureCallback,
    };
    HttpServices.Post(postProps);
  };
  const checkAuthoCodeReceivedFromFacebook = () => {
    if (isCustomDomain) {
      const handleMessage = (event) => {
        const { type, code } = event.data;
        if (type === 'inst_auth_code' && code && !isProcessing) {
          isProcessing = true;
          window.removeEventListener('message', handleMessage, false); // Remove event listener
          clearInterval(intervalId); // Stop polling
          getInstagramAccounts(code); // Process the code
        }
      };

      window.addEventListener('message', handleMessage, false);
    } else {
      var code = localStorage.getItem('inst_autho_code');
      var error = localStorage.getItem('inst_error');
      if (code) {
        localStorage.removeItem('inst_autho_code');
        clearInterval(intervalId);
        getInstagramAccounts(code);
      } else if (error) {
        localStorage.removeItem('inst_error');
        clearInterval(intervalId);
        showToast(error, 'e');
      }
    }
  };

  const getInstagramOauthToken = () => {
    window.open(
      `https://www.instagram.com/oauth/authorize?force_reauth=true&client_id=${Config.Instagram.appId}&redirect_uri=${Config.Instagram.redirectUri}&response_type=code&scope=${Config.Instagram.scope}`,
      '_blank'
    );
  };

  return (
    <>
      {isAuthorizationModalOpen && (
        <InstagramDirectAuthorizationModal
          handleConnectInstagram={getInstagramOauthToken}
          handleClose={handleClose}
          reAuth={true}
        />
      )}
      {isCustomDomain && (
        <CustomDomainRedirectIframe serviceName={PostUtil.ServiceName.INSTAGRAM} profileType={PostUtil.ProfileType.DIRECT_PROFILE} />
      )}
    </>
  );
};
export default InstagramDirectReAuthenticate